import React from 'react';

import Icon from '../Icon/Icon';

const ArrowRightIcon = (props) => {
    return (
        <Icon width='24' height='24' stroke='#34303D' {...props}>
            <g strokeWidth='1.5' fill='none' fillRule='evenodd'>
                <path d='M14.77 17.5L20 12.27L14.77 7.038' />
                <path d='M18.675 12.269L3.675 12.269' />
            </g>
        </Icon>
    );
};

export default ArrowRightIcon;
